import React from 'react';
import { GoogleTagManager } from './components/GoogleTagManager';
export function App() {
  return <div className="bg-white min-h-screen font-sans text-gray-900" data-id="element-0">
      <GoogleTagManager gtmId="GTM-WBW5XHKP" data-id="element-1" />
      <header className="bg-blue-900 text-white py-4 sticky top-0 z-50" data-id="element-2">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-3">
          <div className="text-xl font-bold" data-id="element-4">Página Principal</div>
          <a href="/lp1" className="bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold py-2 px-4 rounded-lg transition-colors" data-id="element-5">
            Ver Landing Page
          </a>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-6">
        <div className="text-center" data-id="element-7">
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight text-blue-900" data-id="element-8">
            Página Principal
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-700" data-id="element-9">
            Esta es la página principal, completamente independiente de la
            landing page.
          </p>
          <div className="mt-8" data-id="element-10">
            <a href="/lp1" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg transition-colors" data-id="element-11">
              Ir a la Landing Page
            </a>
          </div>
        </div>
      </main>
      <footer className="bg-gray-100 py-12 mt-16" data-id="element-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-13">
          <p className="text-sm text-gray-500" data-id="element-14">
            © 2025 All Rights Reserved
          </p>
        </div>
      </footer>
    </div>;
}